import Vue from 'vue';
import {ListenerOperationConstant} from './Constants';
import VueCookie from "vue-cookie";
import {formatLocale} from "./localeUtil";

const ListenerPopHelper = {};

//中英文对应不同的样式（some questions here
const getClass = () => {
  let loc = formatLocale(VueCookie.get("jdcloud_sitelang"));
  if (loc === 'zh-CN') {
    return {style: 'text-align: left;'};
  } else {
    return {style: 'text-align: left; word-break: keep-all'};
  }
};

export function operations(caseOps, target, params, type, disabled) {
  const param = {
    region: params.region,
    listenerId: params.listenerId,
  };
  switch (parseInt(caseOps)) {
    // 编辑
    case ListenerOperationConstant.EDIT:{
      // 跳转到编辑监听器页面
      target.$router.push(
        {
          path: '/lb/listener/edit',
          query: {
            region: params.region,
            listenerId: params.listenerId,
            type: 'edit',
            loadBalancerId: params.loadBalancerId
          }
        }
      )
      break;
    }
    // 开启
    case ListenerOperationConstant.OPEN:{
      const h = target.$createElement;
      target.$msgbox({
        title: target.$t('slb.text.openListener'),
        message: h('p', getClass(), [
          h('span', null, target.$t('slb.sentence.open', [params.name])),
        ]),
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: target.$t('popHelper.text.sure'),
        cancelButtonText: target.$t('popHelper.text.cancel'),
      }).then(() => {
        Ajax.put('/api/cps/startListener', param)
          .then(() => {
            target.$message.success(target.$t('subnet.text.operationSuccess'));
            if (type === 'list') {
              target.updateListenerList();
            } else if (type === 'detail') {
              target.getListenerData();
            }
          })
          .catch(async (err) => {
            const {response} = err.data;
            try {
              const json = await response.json();
              target.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          })
      });
      break;
    }
    // 关闭
    case ListenerOperationConstant.CLOSE:{
      const h = target.$createElement;
      target.$msgbox({
        title: target.$t('slb.text.closeListener'),
        message: h('p', getClass(), [
          h('span', null, target.$t('slb.sentence.close', [params.name])),
        ]),
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: target.$t('popHelper.text.sure'),
        cancelButtonText: target.$t('popHelper.text.cancel'),
      }).then(() => {
        Ajax.put('/api/cps/stopListener', param)
          .then(() => {
            target.$message.success(target.$t('subnet.text.operationSuccess'));
            if (type === 'list') {
              target.updateListenerList();
            } else if (type === 'detail') {
              target.getListenerData();
            }
          })
          .catch(async (err) => {
            const {response} = err.data;
            try {
              const json = await response.json();
              target.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          })
      });
      break;
    }
    // 删除
    // case ListenerOperationConstant.DELETE:{
    //   const h = target.$createElement;
    //   target.$msgbox({
    //     title: target.$t('slb.text.deleteListener'),
    //     message: h('p', getClass(), [
    //       h('jc-alert',null, target.$t('slb.sentence.deleteInfo')),
    //       h('br', null ),
    //       h('span', null, target.$t('slb.sentence.delete', [params.name])),
    //     ]),
    //     closeOnClickModal: false,
    //     showCancelButton: true,
    //     confirmButtonText: target.$t('popHelper.text.sure'),
    //     cancelButtonText: target.$t('popHelper.text.cancel'),
    //   }).then(() => {
    //     Ajax.del('/api/cps/listeners', param)
    //       .then(() => {
    //         if (type === 'list') {
    //           target.updateListenerList();
    //         } else if (type === 'detail') {
    //           target.getListenerData();
    //         }
    //       })
    //       .catch(async (err) => {
    //         const {response} = err.data;
    //         try {
    //           const json = await response.json();
    //           target.$message.error(json.errmsg);
    //         } catch (ex) {
    //           console.log(ex);
    //         }
    //       })
    //       .finally(() => {
    //       })
    //   });
    //   break;
    // }
  }
}

/**
 * 删除默认服务器组中的实例
 * @param target
 * @param params
 */
export function deleteServerCps(target, params) {
  const h = target.$createElement;
  target.$msgbox({
    title: target.$t('slb.serverGroup.remove'),
    message: h('p', getClass(), [
      h('span', null, target.$t('slb.serverGroup.removeTip', [params.name])),
    ]),
    closeOnClickModal: false,
    showCancelButton: true,
    cancelButtonText: target.$t('popHelper.text.cancel'),
    confirmButtonText: target.$t('popHelper.text.sure'),
  }).then(() => {
    const removeParams = {
      serverId: params.serverId,
      region: params.region,
      listenerId: '',
    };
    Ajax.del('/api/cps/listeners/servers', removeParams)
      .then(res => {
      })
      .catch(async (err) => {
        const { response } = err.data;
        try {
          const json = await response.json();
          target.$message.error(json.errmsg);
        } catch (ex) {
          console.log(ex);
        }
      })
      .finally(() => {
        target.refreshGroupList({});
      });
  });
}

export default ListenerPopHelper;



// WEBPACK FOOTER //
// ./src/common/ListenerPopHelper.js